const faqs = [
  {
    q: '91黑料是什么网站？',
    a: '91黑料是一个聚合全网娱乐圈八卦、社会热点揭秘、网红爆料等精彩内容的资讯平台。我们每日实时更新最新的黑料视频和爆料资讯，为用户提供最新最全的黑料网站入口和在线观看地址。本站内容来自网络公开信息整理，仅供娱乐参考。',
  },
  {
    q: '如何找到91黑料的最新地址？',
    a: '建议将本站首页加入浏览器收藏夹，或添加到手机桌面快捷方式。本站域名会通过官方渠道实时更新，您也可以通过搜索引擎搜索"91黑料最新地址"或"91黑料官网"找到我们。请注意甄别仿冒站点，认准本站唯一官方入口。',
  },
  {
    q: '91黑料的内容多久更新一次？',
    a: '本站实行7×24小时不间断更新机制，编辑团队全天候监控全网热点，确保您第一时间看到最新爆料。重大事件发生时，我们会在30分钟内发布相关信息。普通内容每日更新量在100条以上，热门板块每2小时刷新一次。',
  },
  {
    q: '如何向91黑料投稿或爆料？',
    a: '我们欢迎广大网友提供有价值的爆料线索。您可以通过页面底部的"投稿爆料"入口提交您的线索，我们的编辑团队会在24小时内进行审核。对于高质量独家爆料，我们提供丰厚的线索奖励。所有投稿均严格保护爆料人隐私。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            ❓ 常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于91黑料，您想了解的一切都在这里
          </p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-3">
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}